export default {"src":"/_next/static/media/fast-delivery.09193283.svg","height":17,"width":31,"blurWidth":0,"blurHeight":0};